export default {
    GET_CONFIG: 'GET_CONFIG'
};
